import { fallbackRecipes } from "./data";
import type { Recipe, Video } from "./types";
import bundledCatalog from "../public/catalog.json";
import bundledPlayback from "../public/playback.json";

export const initialVideos: Video[] = (bundledCatalog as Video[]).map((video) => ({
  ...video, adTagUrl: bundledPlayback.adTagUrl || undefined
}));

async function fetchJson<T>(url: string, fallback: T): Promise<T> {
  try {
    const response = await fetch(url, {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) return fallback;
    return (await response.json()) as T;
  } catch {
    return fallback;
  }
}

export async function loadVideos(): Promise<Video[]> {
  const [videos, config] = await Promise.all([
    fetchJson<Video[]>("/catalog.json", initialVideos),
    fetchJson<{ sources?: Record<string, Video["playback"]>; adTagUrl?: string }>("/playback.json", bundledPlayback as { sources: Record<string, Video["playback"]>; adTagUrl: string })
  ]);
  return (videos.length ? videos : initialVideos).map((video) => {
    const source = config.sources?.[video.id] ?? video.playback;
    const validSource = source && /^https:\/\//.test(source.src) &&
      ["video/mp4", "application/x-mpegURL"].includes(source.type);
    return { ...video, playback: validSource ? source : undefined,
      adTagUrl: config.adTagUrl?.startsWith("https://") ? config.adTagUrl : undefined };
  });
}

export async function loadRecipes(): Promise<Recipe[]> {
  const recipes = await fetchJson<Recipe[]>("/api/recipes", fallbackRecipes);
  return recipes.length ? recipes : fallbackRecipes;
}
